var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPublish(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "#09FFD2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5548 26.6156C12.5548 27.0446 12.2073 27.3939 11.7774 27.3939C11.349 27.3939 11 27.0446 11 26.6156C11 19.101 17.094 13 24.6 13C32.106 13 38.2 19.101 38.2 26.6156C38.2 27.0446 37.8525 27.3939 37.4226 27.3939C36.9942 27.3939 36.6452 27.0446 36.6452 26.6156C36.6452 19.9588 31.2477 14.5566 24.6 14.5566C17.9508 14.5566 12.5548 19.9603 12.5548 26.6156ZM24.6 18.9316C29.581 18.9316 33.6238 22.9795 33.6238 27.9658C33.6238 32.9525 29.5806 37 24.6 37C19.619 37 15.5762 32.9521 15.5762 27.9658C15.5762 22.9791 19.6194 18.9316 24.6 18.9316ZM24.6 20.4882C20.4773 20.4882 17.1295 23.8387 17.1295 27.9658C17.1295 32.0929 20.4761 35.4449 24.6 35.4449C28.7227 35.4449 32.069 32.0945 32.069 27.9658C32.069 23.8383 28.7224 20.4882 24.6 20.4882ZM30.1226 24.5681C30.5128 24.3883 30.9751 24.5593 31.1533 24.9499C31.3329 25.3405 31.1606 25.8033 30.7719 25.9817L24.9237 28.6718C24.5335 28.8517 24.0712 28.6807 23.893 28.2901C23.7134 27.8994 23.8842 27.4366 24.2743 27.2582L30.1211 24.5681H30.1226Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPublish);
export default __webpack_public_path__ + "static/media/iconPublish.8c6230c357c1fbce109114da9089e0c3.svg";
export { ForwardRef as ReactComponent };